import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=b2be8450&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"
import style0 from "./Profile.vue?vue&type=style&index=0&id=b2be8450&prod&scoped=true&lang=css"
import style1 from "./Profile.vue?vue&type=style&index=1&id=b2be8450&prod&lang=css"
import style2 from "./Profile.vue?vue&type=style&index=2&id=b2be8450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2be8450",
  null
  
)

export default component.exports